// This file is generated by packages/cli/scripts/generate-mcp-api-operations.ts. Do not edit by hand.
// Scope: API-prefixed Mastra server CLI commands only; origin-relative Factory/platform commands are excluded.

export const MASTRA_API_OPERATIONS = [
  {
    name: 'agent_list',
    description: 'List available agents',
    method: 'GET',
    path: '/agents',
    destructive: false,
  },
  {
    name: 'agent_get',
    description: 'Get agent details',
    method: 'GET',
    path: '/agents/:agentId',
    destructive: false,
  },
  {
    name: 'agent_run',
    description: 'Run an agent with JSON input',
    method: 'POST',
    path: '/agents/:agentId/generate',
    destructive: true,
  },
  {
    name: 'workflow_list',
    description: 'List available workflows',
    method: 'GET',
    path: '/workflows',
    destructive: false,
  },
  {
    name: 'workflow_get',
    description: 'Get workflow details',
    method: 'GET',
    path: '/workflows/:workflowId',
    destructive: false,
  },
  {
    name: 'workflow_run_start',
    description: 'Start a workflow run',
    method: 'POST',
    path: '/workflows/:workflowId/start-async',
    destructive: true,
  },
  {
    name: 'workflow_run_list',
    description: 'List workflow runs',
    method: 'GET',
    path: '/workflows/:workflowId/runs',
    destructive: false,
  },
  {
    name: 'workflow_run_get',
    description: 'Get workflow run details',
    method: 'GET',
    path: '/workflows/:workflowId/runs/:runId',
    destructive: false,
  },
  {
    name: 'workflow_run_resume',
    description: 'Resume a suspended workflow run',
    method: 'POST',
    path: '/workflows/:workflowId/resume-async',
    destructive: true,
  },
  {
    name: 'workflow_run_cancel',
    description: 'Cancel a workflow run',
    method: 'POST',
    path: '/workflows/:workflowId/runs/:runId/cancel',
    destructive: true,
  },
  {
    name: 'tool_list',
    description: 'List available tools',
    method: 'GET',
    path: '/tools',
    destructive: false,
  },
  {
    name: 'tool_get',
    description: 'Get tool details and input schema',
    method: 'GET',
    path: '/tools/:toolId',
    destructive: false,
  },
  {
    name: 'tool_execute',
    description: 'Execute a tool with JSON input',
    method: 'POST',
    path: '/tools/:toolId/execute',
    destructive: true,
  },
  {
    name: 'mcp_list',
    description: 'List MCP servers',
    method: 'GET',
    path: '/mcp/v0/servers',
    destructive: false,
  },
  {
    name: 'mcp_get',
    description: 'Get MCP server details',
    method: 'GET',
    path: '/mcp/v0/servers/:id',
    destructive: false,
  },
  {
    name: 'mcp_tool_list',
    description: 'List tools for an MCP server',
    method: 'GET',
    path: '/mcp/:serverId/tools',
    destructive: false,
  },
  {
    name: 'mcp_tool_get',
    description: 'Get MCP tool details',
    method: 'GET',
    path: '/mcp/:serverId/tools/:toolId',
    destructive: false,
  },
  {
    name: 'mcp_tool_execute',
    description: 'Execute an MCP tool with JSON input',
    method: 'POST',
    path: '/mcp/:serverId/tools/:toolId/execute',
    destructive: true,
  },
  {
    name: 'thread_list',
    description: 'List memory threads',
    method: 'GET',
    path: '/memory/threads',
    destructive: false,
  },
  {
    name: 'thread_get',
    description: 'Get thread details',
    method: 'GET',
    path: '/memory/threads/:threadId',
    destructive: false,
  },
  {
    name: 'thread_create',
    description: 'Create a memory thread',
    method: 'POST',
    path: '/memory/threads',
    destructive: true,
  },
  {
    name: 'thread_update',
    description: 'Update a memory thread',
    method: 'PATCH',
    path: '/memory/threads/:threadId',
    destructive: true,
  },
  {
    name: 'thread_delete',
    description: 'Delete a memory thread',
    method: 'DELETE',
    path: '/memory/threads/:threadId',
    destructive: true,
  },
  {
    name: 'thread_messages',
    description: 'List messages in a memory thread',
    method: 'GET',
    path: '/memory/threads/:threadId/messages',
    destructive: false,
  },
  {
    name: 'memory_search',
    description: 'Search long-term memory',
    method: 'GET',
    path: '/memory/search',
    destructive: false,
  },
  {
    name: 'memory_current_get',
    description: 'Get current working memory',
    method: 'GET',
    path: '/memory/threads/:threadId/working-memory',
    destructive: false,
  },
  {
    name: 'memory_current_update',
    description: 'Update current working memory',
    method: 'POST',
    path: '/memory/threads/:threadId/working-memory',
    destructive: true,
  },
  {
    name: 'memory_status',
    description: 'Get memory system status',
    method: 'GET',
    path: '/memory/status',
    destructive: false,
  },
  {
    name: 'trace_list',
    description: 'List observability traces',
    method: 'GET',
    path: '/observability/traces/light',
    verbosePath: '/observability/traces',
    destructive: false,
  },
  {
    name: 'trace_get',
    description: 'Get trace details',
    method: 'GET',
    path: '/observability/traces/:traceId/light',
    verbosePath: '/observability/traces/:traceId',
    destructive: false,
  },
  {
    name: 'trace_span',
    description: 'Get a trace span',
    method: 'GET',
    path: '/observability/traces/:traceId/spans/:spanId',
    destructive: false,
  },
  {
    name: 'trace_query',
    description: 'Query observability traces with advanced predicates',
    method: 'POST',
    path: '/observability/traces/query',
    destructive: true,
  },
  {
    name: 'log_list',
    description: 'List runtime logs',
    method: 'GET',
    path: '/observability/logs',
    destructive: false,
  },
  {
    name: 'metric_aggregate',
    description: 'Get an aggregate metric value',
    method: 'POST',
    path: '/observability/metrics/aggregate',
    destructive: true,
  },
  {
    name: 'metric_breakdown',
    description: 'Get metric values grouped by a label or field',
    method: 'POST',
    path: '/observability/metrics/breakdown',
    destructive: true,
  },
  {
    name: 'metric_timeseries',
    description: 'Get metric values over time',
    method: 'POST',
    path: '/observability/metrics/timeseries',
    destructive: true,
  },
  {
    name: 'metric_percentiles',
    description: 'Get metric percentile values over time',
    method: 'POST',
    path: '/observability/metrics/percentiles',
    destructive: true,
  },
  {
    name: 'metric_names',
    description: 'List discovered metric names',
    method: 'GET',
    path: '/observability/discovery/metric-names',
    destructive: false,
  },
  {
    name: 'metric_label_keys',
    description: 'List label keys for a metric',
    method: 'GET',
    path: '/observability/discovery/metric-label-keys',
    destructive: false,
  },
  {
    name: 'metric_label_values',
    description: 'List label values for a metric label key',
    method: 'GET',
    path: '/observability/discovery/metric-label-values',
    destructive: false,
  },
  {
    name: 'score_create',
    description: 'Create a score',
    method: 'POST',
    path: '/observability/scores',
    destructive: true,
  },
  {
    name: 'score_list',
    description: 'List scores',
    method: 'GET',
    path: '/observability/scores',
    destructive: false,
  },
  {
    name: 'score_get',
    description: 'Get score details',
    method: 'GET',
    path: '/observability/scores/:scoreId',
    destructive: false,
  },
  {
    name: 'score_delete',
    description: 'Delete scores by ID',
    method: 'DELETE',
    path: '/observability/scores',
    destructive: true,
  },
  {
    name: 'feedback_delete',
    description: 'Delete feedback by ID',
    method: 'DELETE',
    path: '/observability/feedback',
    destructive: true,
  },
  {
    name: 'dataset_list',
    description: 'List datasets',
    method: 'GET',
    path: '/datasets',
    destructive: false,
  },
  {
    name: 'dataset_get',
    description: 'Get dataset details',
    method: 'GET',
    path: '/datasets/:datasetId',
    destructive: false,
  },
  {
    name: 'dataset_create',
    description: 'Create a dataset',
    method: 'POST',
    path: '/datasets',
    destructive: true,
  },
  {
    name: 'dataset_items',
    description: 'List dataset items',
    method: 'GET',
    path: '/datasets/:datasetId/items',
    destructive: false,
  },
  {
    name: 'experiment_list',
    description: 'List dataset experiments',
    method: 'GET',
    path: '/datasets/:datasetId/experiments',
    destructive: false,
  },
  {
    name: 'experiment_get',
    description: 'Get experiment details',
    method: 'GET',
    path: '/datasets/:datasetId/experiments/:experimentId',
    destructive: false,
  },
  {
    name: 'experiment_run',
    description: 'Run a dataset experiment',
    method: 'POST',
    path: '/datasets/:datasetId/experiments',
    destructive: true,
  },
  {
    name: 'experiment_results',
    description: 'List experiment results',
    method: 'GET',
    path: '/datasets/:datasetId/experiments/:experimentId/results',
    destructive: false,
  },
  {
    name: 'learning_entities',
    description: 'List entities with Trace Intelligence output',
    method: 'GET',
    path: '/learning/entities',
    destructive: false,
  },
  {
    name: 'learning_snapshots',
    description: 'List analysis snapshots for an entity and ordered trace signals',
    method: 'GET',
    path: '/learning/entities/:entityId/theme-snapshots',
    destructive: false,
  },
  {
    name: 'learning_flow',
    description: 'Get the cross-signal theme flow for one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/theme-flow',
    destructive: false,
  },
  {
    name: 'learning_paths',
    description: 'Get per-trace theme assignments for one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/theme-paths',
    destructive: false,
  },
  {
    name: 'learning_theme_list',
    description: 'List themes for one trace signal in one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/themes',
    destructive: false,
  },
  {
    name: 'learning_theme_get',
    description: 'Get one theme in one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/themes/:themeId',
    destructive: false,
  },
  {
    name: 'learning_theme_examples',
    description: 'List trace examples for one theme in one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/themes/:themeId/examples',
    destructive: false,
  },
  {
    name: 'learning_theme_history',
    description: 'Get lifecycle history for one durable theme',
    method: 'GET',
    path: '/learning/entities/:entityId/themes/:themeId/history',
    destructive: false,
  },
  {
    name: 'learning_noise_get',
    description: 'Get the noise bucket for one trace signal in one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/noise',
    destructive: false,
  },
  {
    name: 'learning_noise_examples',
    description: 'List trace examples for the noise bucket in one snapshot',
    method: 'GET',
    path: '/learning/entities/:entityId/noise/examples',
    destructive: false,
  },
] as const;
